import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { Row, Form, Button } from 'react-bootstrap';
const uuid = require('uuid');

const Strings = require('../../../../app/shared/Strings');
const ResetPasswordStore = require('../../stores/reset_password_store_reflux');
const ResetPasswordActions = require('../../actions/reset_password_actions');
const ValidateUtil = require('../../util/ValidateUtil');
const KeyboardUtil = require('../../util/keyboard');
const UriUtil = require('../../util/UriUtil');
import ErrorBox from '../common/ErrorBox';
import SuccessBox from '../common/SuccessBox';
import SignedOutPromoPanel from './SignedOutPromoPanel';
import SignedOutFooter from './SignedOutFooter';

const propTypes = {
    history: PropTypes.object.isRequired,
    location: PropTypes.shape({
        search: PropTypes.string.isRequired,
    }).isRequired
};

const defaultProps = {};

class ResetPassword extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            password1: "",
            password2: "",
            actionID: null,
            ...ValidateUtil.getDefaultValidationState(),
        };

        this.password1OnChange = this.password1OnChange.bind(this);
        this.password2OnChange = this.password2OnChange.bind(this);
        this.handleKeyDown = this.handleKeyDown.bind(this);
        this.resetHandler = this.resetHandler.bind(this);
        this.unsubscribes = [
            ResetPasswordStore.listen(this.onResetPasswordStoreChange.bind(this))
        ];
    }

    componentDidMount(){
        if (!UriUtil.parseLocationSearchString(this.props.location).key) {
            this.props.history.replace('/signin');
            return;
        }
    }

    componentDidUpdate()  {
        if (this.state.actionSuccess) {
            setTimeout(() => {
                this.props.history.replace('/signin');
            }, 3000);
        }
    }

    componentWillUnmount() {
        this.unsubscribes.forEach(u => u());
    }

    onResetPasswordStoreChange(newState) {
        let updatedState = ValidateUtil.getUpdatedState(this.state.actionID, newState);
        this.setState(updatedState);
    }

    password1OnChange(e) {
        this.setState({ password1: e.target.value });
    }

    password2OnChange(e) {
        this.setState({ password2: e.target.value });
    }

    handleKeyDown(e) {
        if (KeyboardUtil.isEnterKey(e.keyCode)) {
            this.resetHandler();
        }
    }

    resetHandler() {
        const actionID = uuid.v4();
        this.setState({ actionID: actionID }, () => {
            ResetPasswordActions.resetPassword(
                actionID,
                {
                    password: this.state.password1,
                    passwordConfirm: this.state.password2,
                    secret: UriUtil.parseLocationSearchString(this.props.location).key,
                }
            );
        });
    }

    render() {
        return (
            <div className="fill signed-out--new">
                <div className="container rel-centered-v">
                    <div className="signedOutDual">
                        <SignedOutPromoPanel />
                        <div className="signedOutDual__form">
                            <div className="signedOutDual__formHeaderArea">
                                <h2 className="signedOutDual__formHeaderArea--header">
                                    {Strings['en'].signed_out.sign_in_new.forgot_form.RESET_PASSWORD}
                                </h2>
                            </div>
                            <div>
                                <ErrorBox error={this.state.error} />
                                {this.state.actionSuccess && <SuccessBox message={this.state.successMessage} />}
                                <div style={this.state.actionSuccess? {display: 'none'} : {display: 'block'}}>
                                    <Form.Group controlId="reset-password">
                                        <Form.Label>{Strings['en'].signed_out.sign_in_new.forgot_form.NEW_PASSWORD}</Form.Label>
                                        <Form.Control
                                            type="password"
                                            aria-label={Strings['en'].signed_out.sign_in_new.forgot_form.NEW_PASSWORD}
                                            onChange={this.password1OnChange}
                                            onKeyDown={this.handleKeyDown}
                                            isInvalid={ValidateUtil.isInvalid(this.state, 'password')}
                                        />
                                    </Form.Group>
                                    <Form.Group controlId="reset-confirm-password">
                                        <Form.Label>{Strings['en'].signed_out.sign_in_new.forgot_form.NEW_PASSWORD_CONFIRM}</Form.Label>
                                        <Form.Control
                                            type="password"
                                            aria-label={Strings['en'].signed_out.sign_in_new.forgot_form.NEW_PASSWORD_CONFIRM}
                                            onChange={this.password2OnChange}
                                            onKeyDown={this.handleKeyDown}
                                            isInvalid={ValidateUtil.isInvalid(this.state, 'passwordConfirm')}
                                        />
                                    </Form.Group>
                                    <div className="signedOutDual__buttonRow margin-top-lg">
                                        <Button
                                            disabled={this.state.actionSuccess}
                                            onClick={this.resetHandler}
                                        >
                                            {Strings['en'].signed_out.sign_in_new.forgot_form.RESET_PASSWORD_BTN_LBL}
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <SignedOutFooter />
            </div>
        );
    }
}

ResetPassword.propTypes = propTypes;
ResetPassword.defaultProps = defaultProps;

export default withRouter(ResetPassword);